<template>
  <div id="previewBlockRevision">
    <!-- Block Details -->
    <b-card
      id="blockDetailsCard"
      class="blockDrawer large"
      :class="$store.state.drawer.previewBlockRevision.position"
    >
      <template v-slot:header>
        <a
          class="close clickable"
          @click="hideBlockDetails()"
        >
          <i class="far fa-times"></i>
        </a>
        <!-- Block Title -->
        <h4 id="blockTitle">{{ $store.state.block.name }} (Past Version)</h4>
        <!-- Block Settings Button -->
        <!-- <b-btn
          v-if="$store.state.role == 'Administrator' || $store.state.role == 'Editor'"
          @click="editBlockSettings()"
          id="blockSettings"
          class="mb-2"
        >
          <i class="fas fa-cog"></i> Block Settings
        </b-btn> -->
        <b-btn
          v-if="$store.state.role == 'Administrator' || $store.state.role == 'Editor'"
          @click="promptConfirmRevert = true"
          class="mb-2 ml-1"
        >
          <i class="fas fa-history"></i> Revert
        </b-btn>
      </template>
      <p>{{ $store.state.revision.description }}</p>
      <p v-if="$store.state.userProfile.measurementSystem === 'Metric'"><strong>Area:</strong> {{ $store.state.revision.area | toHectares }} hectares</p>
      <p v-if="$store.state.userProfile.measurementSystem === 'Imperial'"><strong>Area:</strong> {{ $store.state.revision.area | toAcres }} acres</p>
      <div v-if="$store.state.farm.blockFields && $store.state.farm.blockFields.length > 0">
        <!-- FIELDS -->
        <div
          v-for="(field, i) in $store.state.farm.blockFields"
          v-bind:key="i"
        >
          <!-- TEXT FIELDS -->
          <p
            v-if="field.type !== 'Image'"
          ><strong>{{ field.label }}:</strong> {{ $store.state.revision[field.machine_name] }} <span v-if="$store.state.farm.blockFields[i].suffix">{{ $store.state.farm.blockFields[i].suffix }}</span></p>
          <!-- IMAGE GALLERY -->
          <p
            v-if="field.type === 'Image' && slideshowsReady"
          ><strong>{{ field.label }}</strong></p>
          <b-carousel
            v-if="field.type === 'Image' && slideshowsReady && !fullscreenSlides"
            :id="field.machine_name"
            controls
            indicators
            class="mb-4"
          >
            <b-carousel-slide
              v-for="(image, i) in slideshows[field.machine_name].slides"
              v-bind:key="i"
              :img-src="image.url"
            ></b-carousel-slide>
            <b-btn
              @click="fullscreenSlides = true"
              class="fullscreenButton"
            ><i class="fas fa-expand"></i></b-btn>
          </b-carousel>
          <!-- FULL SCREEN GALLERY -->
          <div
            class="fullscreenSlideshow"
            v-if="field.type === 'Image' && slideshowsReady && fullscreenSlides"
          >
            <b-carousel
              :id="field.machine_name + '_fullscreen'"
              controls
              indicators
            >
              <b-carousel-slide
                v-for="(image, i) in slideshows[field.machine_name].slides"
                v-bind:key="i"
                :img-src="image.url"
              >
                <b-btn @click="downloadImage(image)" class="downloadImageBtn"><i class="fas fa-download"></i> Download Image</b-btn>
              </b-carousel-slide>
            </b-carousel>
            <b-btn
              @click="fullscreenSlides = false"
              class="closeButton"
            ><i class="fas fa-times"></i> Close</b-btn>
          </div><!-- /FULLSCREEN SLIDESHOW -->
        </div><!-- /FIELDS -->
        <p v-if="$store.state.revision.updatedOn != undefined"><strong>Updated:</strong> {{ $store.state.revision.updatedOn | dateTime }}</p>
        <p v-if="$store.state.revision.createdOn != undefined"><strong>Created:</strong> {{ $store.state.revision.createdOn | dateTime }}</p>
      </div><!-- if dynamic -->
    </b-card>
    <Confirm
      v-if="promptConfirmRevert"
      text="Are you sure you want to revert to this version of the block? A new version will also be created using the current block."
      v-on:confirmed="revert($event)"
    />
  </div><!-- /#previewBlockRevision -->
</template>

<script>
import Confirm from '../Confirm'
import moment from 'moment'
import firebase from 'firebase/compat/app'
const fb = require('../../firebaseConfig.js')

export default {
  data () {
    return {
      slideshows: {},
      slideshowsReady: false,
      fullscreenSlides: false,
      promptConfirmRevert: false
    }
  },
  computed: {
    revision: {
      get () {
        return this.$store.state.revision
      },
      set (value) {
        this.$store.commit('setStateProperty', { property: 'revision', value: value })
      }
    },
    block: {
      get () {
        return this.$store.state.block
      },
      set (value) {
        this.$store.commit('setStateProperty', { property: 'block', value: value })
      }
    },
    farm: {
      get () {
        return this.$store.state.farm
      },
      set (value) {
        this.$store.commit('setStateProperty', { property: 'farm', value: value })
      }
    }
  },
  components: {
    Confirm
  },
  created () {
    // this.getImageUrls()
    this.formatFields()
    this.highlightVersionBlock()
  },
  destroyed () {
    if (this.$store.state.mapObject.getLayer('blockHighlightLayer')) {
      this.$store.state.mapObject.removeLayer('blockHighlightLayer')
      this.$store.state.mapObject.removeSource('blockHighlightLayer')
    }
  },
  methods: {
    highlightVersionBlock () {
      // Add highlighted block layer
      if (this.$store.state.mapObject.getLayer('blockHighlightLayer')) {
        this.$store.state.mapObject.removeLayer('blockHighlightLayer')
        this.$store.state.mapObject.removeSource('blockHighlightLayer')
      }
      const geoJson = JSON.parse(this.revision.footprint)
      this.$store.state.mapObject.addLayer({
        id: 'blockHighlightLayer',
        type: 'fill',
        source: {
          type: 'geojson',
          data: geoJson
        },
        layout: {},
        paint: {
          'fill-color': '#ffc107', // eslint-disable-line
          'fill-opacity': 0.8 // eslint-disable-line
        }
      })
    },
    revert (confirmed) {
      this.promptConfirmRevert = false
      if (confirmed) {
        console.log('Revert')
        // Create a revision with the current doc
        fb.blocksCollection.doc(this.block.id).get().then(blockDoc => {
          const blockData = blockDoc.data()
          
          // Create a clean copy for revision (without id field to avoid conflicts)
          const revisionData = { ...blockData }
          delete revisionData.id
          
          return fb.blocksCollection.doc(blockData.id).collection('revisions').add(revisionData)
        }).then(() => {
          this.revision.updatedOn = new Date()
          this.revision.updatedBy = this.$store.state.currentUser.uid
          this.revision.revisionMessage = 'Reverted to previous version: ' + this.revision.revisionMessage
          return fb.blocksCollection.doc(this.block.id).update(this.revision)
        }).then(() => {
          // Mark the farm to recompile
          return fb.farmsCollection.doc(this.farm.id).update({
            recompileBlocks: true
          })
        }).then(() => {
          this.block = this.revision
          this.$store.commit('setAlert', { active: true, message: 'Block Updated! Recompiling map now...', level: 'alert-success' })
          this.$store.commit('hideDrawer', 'previewBlockRevision')
          return this.$store.dispatch('removeAllLayers')
        }).then(() => {
          const map = this.$store.state.mapObject
          map.removeControl(this.drawControlsObject)
          this.drawControlsObject = false
          this.$store.dispatch('removeAllLayers')
          setTimeout(() => {
            return this.$store.dispatch('initFarmMap')
          }, 300)
        }).catch(err => {
          console.log(err)
        })
      } else {
        console.log('Cancelled')
      }
    },
    downloadImage (image) {
      firebase.storage().ref(image.path).getDownloadURL().then(url => {
        window.open(url, '_blank')
      })
    },
    getImageUrls () {
      if (this.$store.state.farm.blockFields) {
        this.$store.state.farm.blockFields.forEach(field => {
          if (field.type === 'Image') {
            if (this.$store.state.revision[field.machine_name]) {
              this.slideshows[field.machine_name] = {
                slides: [],
                show: false
              }
              this.$store.state.revision[field.machine_name].forEach(image => {
                firebase.storage().ref(image.large).getDownloadURL().then(url => {
                  this.slideshows[field.machine_name].slides.push({
                    path: image.path,
                    url: url
                  })
                  if (this.slideshows[field.machine_name].slides.length === this.$store.state.revision[field.machine_name].length) {
                    this.slideshows[field.machine_name].show = true
                    this.$store.state.farm.blockFields.forEach(field => {
                      let readyToShowSlideshows = true
                      if (field.type === 'Image' && !this.slideshows[field.machine_name].show) {
                        readyToShowSlideshows = false
                      }
                      this.slideshowsReady = readyToShowSlideshows
                    })
                  }
                })
              })
            }
          }
        })
      }
    },
    getImageUrl (image, field) {
      return firebase.storage().ref(image.large).getDownloadURL().then(url => {
        this.slideshows[field.machine_name].slides.push({
          path: image.path,
          url: url,
          caption: image.caption
        })
        return true
      }).catch(err => {
        console.log(err)
        return false
      })
    },
    hideBlockDetails () {
      if (this.$store.state.mapObject.getLayer('blockHighlightLayer')) {
        this.$store.state.mapObject.removeLayer('blockHighlightLayer')
      }
      if (this.$store.state.mapObject.getSource('blockHighlightLayer')) {
        this.$store.state.mapObject.removeSource('blockHighlightLayer')
      }
      // Hide the details
      this.$store.commit('hideDrawer', 'previewBlockRevision')
      setTimeout(() => {
        this.$store.commit('showDrawer', 'blockRevisions')
      }, 300)
    },
    // editBlockSettings () {
    //   // this.$store.commit('setDrawer', { name: 'blockDetails', position: 'out' })
    //   this.$store.commit('hideDrawer', 'blockDetails')
    //   this.$store.commit('setEditMode', true)
    //   const self = this
    //   setTimeout(function () {
    //     // self.$store.commit('toggleModal', 'createBlock')
    //     // self.$store.commit('setStateProperty', { property: 'showCreateBlockDrawer', value: true })
    //     // self.$store.commit('setDrawer', { name: 'createBlockDrawer', position: 'in' })
    //     self.$store.commit('showDrawer', 'createBlockDrawer')
    //   }, 300)
    // },
    formatFields () {
      this.$store.state.farm.blockFields.forEach(field => {
        if (this.$store.state.revision[field.machine_name] && field.type === 'Image') {
          this.slideshows[field.machine_name] = {
            slides: [],
            show: false
          }
          const imagePromises = []
          this.$store.state.revision[field.machine_name].forEach(image => {
            const prom = this.getImageUrl(image, field)
            imagePromises.push(prom)
          })
          Promise.all(imagePromises).then(() => {
            this.slideshowsReady = true
          })
        } else if (this.$store.state.revision[field.machine_name] && field.type === 'Formatted Text') {
          const content = this.$store.state.revision[field.machine_name]
          const fixParenthesis = content.replace(/�s/g, '\'s')
          const removeSpecial = fixParenthesis.replace(/�/g, '"')
          this.$store.state.revision[field.machine_name] = removeSpecial
        }
      })
    }
  },
  filters: {
    toAcres (val) {
      const acres = val * 0.000247105
      const rounded = acres.toFixed(2)
      return rounded
    },
    toHectares (val) {
      const hectares = val / 10000
      const rounded = hectares.toFixed(2)
      return rounded
    },
    dateTime (val) {
      if (val === {}) { return '-' }
      const date = val.toDate()
      return moment(date).fromNow()
      // return moment(date).format('MMMM Do YYYY, h:mm a')
    }
  }
}
</script>
